<template lang="pug">
     .section(
        :class='data.theme',
        v-observe-visibility='visibilityChanged'
        )
        ScrollTrigger(
            :color='theme',
            )
        span(v-html='theme')
        .textwrapper(
            v-if='data.type === "text"'
            )

            .section-heading(
                v-if='data.title'
                )
                ArticleTitle(:title='data.title', color='black', :isActive='isActive')

            .section-block.section-block--developers(
                v-for='(block, blockIndex) in data.content',
                :class='[block.position, block.modifier]'
                :data-section-block-index='blockIndex'
                )

                .texts(v-if='block.type === "text"' :isActive='isActive')
                    ul.developers-list(v-if='Array.isArray(block.textblocks)' v-html='block.textblocks.join("")')
                    
                    
        //-ScrollTrigger(
            :color='content.theme',
            :position='"bottom"'
            )
</template>
<script>
import data from '@/assets/data/developers';
export default {
    components: {
        ArticleTitle: () => import('../components/ArticleTitle.vue')
    },
    data() {
        return {
            isActive: false,
            data
        };
    },
    props: {
        theme: String,
        content: Object
    },
    methods: {
        setArticleText() {
            this.articleText = this.$store.getters.getArticle(this.articleId, this.sectionId, this.categoryId).footer.text;
        },
        visibilityChanged(isVisible) {
            if (isVisible) this.isActive = true;
            else this.isActive = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';
.section {
    position: relative;
    min-height: 100vh;
    background-color: var(--color-black);
    color: var(--color-white);
}
.section-heading {
    padding: 80px 0 40px;

    @media (--viewport-tablet) {
        padding: 0;
        padding: 30px 0;
    }
}
</style>
<style lang="scss">
@import '../assets/css/vars.scss';
.developers-list {
    margin: auto;
    width: calc(var(--grid-column) * 17);
    @media (--viewport-laptop) {
        width: calc(var(--grid-column-mobile) * 11);
        //padding: 0 calc(var(--grid-column-laptop) * 1);
        margin-left: var(--grid-column-mobile);
    }
    li {
        display: flex;
        margin-bottom: 15px;
        span {
            &:first-child {
                flex-basis: 30%;
            }
            &:nth-child(2) {
                flex-basis: 70%;
                @media (--viewport-tablet) {
                    padding-left: var(--grid-column-mobile);
                    max-width: 200px;
                }
                //flex-grow: 1;
            }
        }
        @media (--viewport-mobile-l) {
            flex-direction: column;
        }
    }
}
.section-block--developers {
    padding: 40px 0 170px;
    @media (--viewport-mobile-l) {
        padding: 0 0 80px;
    }
}
</style>
